import React from 'react';
import cvvIcon from '../../../../assets/images/pro/cvv_icon.png';
import OutlinedTextField from '../textFields/OutlinedTextField';
import * as formStyles from '../styles/styles.module.scss';
import * as styles from './styles/styles.module.scss';
import { FormattedMessage } from 'react-intl';
import CreditCardNumber from './CreditCardNumber';
import CreditCardExpiration from './CreditCardExpiration';

const CardValidator = require('card-validator');

type Props = {
  errors?: {
    expiration?: React.ReactNode;
    name?: React.ReactNode;
    number?: React.ReactNode;
    cvv?: React.ReactNode;
    postalCode?: React.ReactNode;
  };
  changeHandler?(...args: unknown[]): unknown;
  submitHandler?(...args: unknown[]): unknown;
  name?: string;
  number?: string;
  month?: {
    string?: string;
    title?: string;
    value?: string;
  };
  year?: {
    string?: string;
    value?: string;
  };
  cvv?: string;
  postalCode?: string;
  setError: (name: 'expiration' | 'number', error: React.ReactNode) => void;
  expiration?: string;
  toggleCouponCode: () => void;
  isCouponInputExpanded?: boolean;
  isCouponInputShown?: boolean;
};

const CreditCardForm = ({
  errors,
  changeHandler,
  submitHandler,
  name,
  number,
  cvv,
  postalCode,
  setError,
  expiration,
  toggleCouponCode,
  isCouponInputExpanded = false,
  isCouponInputShown = false
}: Props) => {
  const cardInfo = CardValidator.number(number);

  const getFormattedCVVCode = (cvvCode: string) => {
    const response = [];
    let maxLength = 3;

    if (cvvCode) {
      const cvvArray = cvvCode.split('');
      if (cardInfo.card && cardInfo.card.code) {
        maxLength = cardInfo.card.code.size;
      }
      for (let i = 0; i < cvvArray.length; i++) {
        if (i < maxLength) {
          response.push(cvvCode[i].replace(/\D/g, ''));
        }
      }
    }
    return response.join('');
  };

  return (
    <div>
      <div className={formStyles.row}>
        <CreditCardNumber
          changeHandler={changeHandler}
          number={number}
          error={errors.number}
          submitHandler={submitHandler}
          setError={error => setError('number', error)}
        />
      </div>
      <div className={formStyles.row}>
        <CreditCardExpiration
          enterKeyHandler={submitHandler}
          error={errors.expiration}
          onChange={changeHandler}
          setError={error => setError('expiration', error)}
          value={expiration}
        />
        <OutlinedTextField
          name="cvv"
          autocomplete="cc-csc"
          label={<FormattedMessage defaultMessage="CVV" />}
          adornment={<img alt="cvv code" className={styles.cardIcon} src={cvvIcon} />}
          errorMessage={errors.cvv}
          value={getFormattedCVVCode(cvv)}
          changeHandler={changeHandler}
          enterKeyHandler={submitHandler}
          inputMode="numeric"
        />
      </div>
      <div className={formStyles.row}>
        <OutlinedTextField
          name="name"
          autocomplete="cc-name"
          label={<FormattedMessage defaultMessage="Name on card" />}
          errorMessage={errors.name}
          value={name}
          changeHandler={changeHandler}
          enterKeyHandler={submitHandler}
        />
      </div>
      <div className={formStyles.row}>
        <OutlinedTextField
          name="postalCode"
          autocomplete="postal-code"
          label={<FormattedMessage defaultMessage="Zip code" />}
          errorMessage={errors.postalCode}
          value={postalCode}
          changeHandler={changeHandler}
          enterKeyHandler={submitHandler}
        />
        {isCouponInputShown && (
          <div className={styles.couponCol}>
            <button className={styles.couponButton} onClick={toggleCouponCode} type="button">
              {isCouponInputExpanded ? (
                <FormattedMessage defaultMessage="Hide coupon code" />
              ) : (
                <FormattedMessage defaultMessage="Enter a coupon code" />
              )}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

CreditCardForm.defaultProps = {
  changeHandler: () => {},
  submitHandler: () => {},
  name: '',
  number: '',
  month: '',
  year: '',
  cvv: '',
  postalCode: ''
};

export default CreditCardForm;
